import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'
import axios from 'axios';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import packageJson from '../package.json';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: "https://1ce40e867abf4038b68d696010d1913f@o1036946.ingest.sentry.io/4504688243638272",
    integrations: [new BrowserTracing()],
    environment: "production",
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0,
    release: packageJson.version
  });
}

setInterval(() => {
  axios.get(`${process.env.PUBLIC_URL}/version.json`, {
    params: {
      t: Date.now(),
    },
  }).then(({ data }) => {
    if (data.version && packageJson.version !== data.version) {
      window.location.reload();
    }
  })
}, 60 * 60 * 1000);

if (window.innerWidth < 960) {
  const mql = window.matchMedia("(orientation: portrait)");
  if (mql.matches) {
    const w = window.innerWidth
    const scale = w / 960
    document.body.style.transform = `scale(${scale})`
    document.body.style.width = '960px'
    document.body.style.height = '540px'
    document.body.scrollTop = 0
  } else {
    const h = window.innerHeight
    const scale = h / 540
    document.body.style.transform = `scale(${scale})`
    document.body.style.width = '960px'
    document.body.style.height = '540px'
    document.body.style.marginLeft = `${(window.innerWidth - 960 * scale) / 2}px`
    window.scrollTo(0, 0);
  }
}

window.addEventListener('orientationchange', (e) => {
  document.body.style.width = 'auto'
  document.body.style.height = 'auto'
  document.body.style.marginLeft = '0px'
  // in orientationchange need setTimeout for get correct window.innerWidth
  setTimeout(() => {
    const mql = window.matchMedia("(orientation: portrait)");
    if (mql.matches) {
      const w = window.innerWidth
      const scale = w / 960
      document.body.style.transform = `scale(${scale})`
      document.body.style.width = '960px'
      document.body.style.height = '540px'
    } else {
      const h = window.innerHeight
      const scale = h / 540
      document.body.style.transform = `scale(${scale})`
      document.body.style.width = '960px'
      document.body.style.height = '540px'
      document.body.style.marginLeft = `${(window.innerWidth - 960 * scale) / 2}px`
      window.scrollTo(0, 0);
    }
  }, 100)
})

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
